module.exports = __webpack_public_path__ + "assets/images/5HBox.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/5HBox.png
// module id = 1307
// module chunks = 1